(() => {
  function initialize(root) {
    if (!root || root.dataset.homeReady) return;
    const config = JSON.parse(root.querySelector('[data-home-config]').textContent);
    root.dataset.homeReady = 'true';
    const listeners = new AbortController();
    const observers = [];
    const listen = (el, event, callback) => el.addEventListener(event, callback, { signal: listeners.signal });
    const roomButtons = [...root.querySelectorAll('[data-room-state]')];
    roomButtons.forEach(button => listen(button, 'click', () => {
      const state = button.dataset.roomState;
      roomButtons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      root.querySelector('[data-difference-art]').classList.toggle('art-hidden', state === 'before');
      root.querySelector('[data-room-label]').textContent = config.copy[state];
    }));
    const sizes = {
      S: { dimensions: '90 × 60 cm', width: 90, advice: config.copy.smallAdvice },
      M: { dimensions: '120 × 80 cm', width: 120, advice: config.copy.sizeMediumAdvice },
      L: { dimensions: '150 × 100 cm', width: 150, advice: config.copy.largeAdvice }
    };
    function setSize(size) {
      if (!Object.hasOwn(sizes, size)) return;
      const selected = sizes[size];
      root.querySelectorAll('[data-size]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.size === size)));
      const visual = root.querySelector('[data-size-art]');
      visual.innerHTML = config.sizeArt[size];
      visual.style.width = `${selected.width / 220 * 78}%`;
      root.querySelector('.size-measure').style.width = visual.style.width;
      root.querySelector('[data-size-width]').textContent = `${selected.width} cm`;
      root.querySelector('[data-size-dimensions]').textContent = selected.dimensions;
      root.querySelector('[data-size-advice]').textContent = selected.advice;
    }
    root.querySelectorAll('[data-size]').forEach(b => listen(b, 'click', () => setSize(b.dataset.size)));
    setSize('M');
    const bar = root.querySelector('[data-mobile-shop]');
    let pastHero = false, atEnd = false;
    const updateBar = () => { bar.hidden = !pastHero || atEnd; };
    if ('IntersectionObserver' in window) {
      const heroObserver = new IntersectionObserver(([entry]) => { pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0; updateBar(); });
      heroObserver.observe(root.querySelector('.hero'));
      const endObserver = new IntersectionObserver(([entry]) => { atEnd = entry.isIntersecting; updateBar(); });
      endObserver.observe(root.querySelector('.final-section'));
      observers.push(heroObserver, endObserver);
    }
    // Reuse the existing store's consent-controlled analytics; install no new tracker.
    listen(root, 'click', event => {
      const link = event.target.closest('[data-cta]');
      const allowed = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
      if (link && allowed && Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'homepage_cta_click', cta_position: link.dataset.cta, product_handle: link.dataset.product || null, destination: link.href });
    });
    const section = root.closest('.shopify-section');
    listen(document, 'shopify:section:unload', event => { if (event.target === section) { observers.forEach(o => o.disconnect()); listeners.abort(); } });
  }
  document.querySelectorAll('[data-home-root]').forEach(initialize);
  if (!window.fivewallHomeEditorListener) {
    window.fivewallHomeEditorListener = true;
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-home-root]').forEach(initialize));
  }
})();
